import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const SynechronGithubPickerFieldSchema = makeFieldSchema({
  output: z => z.string(),
  uiOptions: z =>
    z.object({
      repoInputTitle: z
        .string()
        .default('Repository Name')
        .optional()
        .describe('Title for the repository input'),
      repoInputDescription: z
        .string()
        .default(
          'The name for the GitHub repository in the synechron organization',
        )
        .optional()
        .describe('Description for the repository input'),
      teamInputTitle: z
        .string()
        .default('Team')
        .optional()
        .describe('Title for the team input'),
      teamInputDescription: z
        .string()
        .default('Select a team to assign to this repository')
        .optional()
        .describe('Description for the team input'),
      domainInputTitle: z
        .string()
        .default('Domain')
        .optional()
        .describe('Title for the domain input'),
      domainInputDescription: z
        .string()
        .default('Select the domain for this repository')
        .optional()
        .describe('Description for the domain input'),
    }),
});

export const SynechronGithubPickerSchema =
  SynechronGithubPickerFieldSchema.schema;
